import { useTranslation } from 'react-i18next'

import { Avatar, Row } from 'common/components'

import styles from './index.module.css'

type CountdownTimerProps = {
  days: number
  defaultContentForMoreThanZeroDays?: string
  defaultContentForZeroDays?: string
}

const CountdownTimer = ({
  days,
  defaultContentForMoreThanZeroDays = 'Days left until open enrollment begins',
  defaultContentForZeroDays = 'Open enrollment has begun',
}: CountdownTimerProps) => {
  return (
    <Row className={styles.countdownCard}>
      {days > 0 && (
        <Avatar className={`center_avatar ${styles.countdownAvatar}`}>
          <span className={styles.countdownText}>
            {days} {days === 1 ? 'Day' : 'Days'}
          </span>
        </Avatar>
      )}

      <div className="center-align-items">
        {days > 0 ? <p>{defaultContentForMoreThanZeroDays}</p> : <p>{defaultContentForZeroDays}</p>}
      </div>
    </Row>
  )
}
export default CountdownTimer
